<template>
  <v-expansion-panels flat accordion multiple :value="state" v-model="expanded">
    <v-expansion-panel v-for="(item, i) in items" :key="`about-expandable-${i.toString()}`">
      <v-expansion-panel-header
        class="text-uppercase px-0"
        @click="expandHandler(i)"
      >
        <span class="text-tcdc-green sub-header1 bold">{{ item.question }}</span>
        <template v-slot:actions>
          <v-icon v-if="expanded.some(index => i === index)" class="text-tcdc-green" size="medium">mdi-minus</v-icon>
          <v-icon v-else class="text-tcdc-green" size="medium">mdi-plus</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="vhtml" v-html="item.answer"></div>
        <!-- <Service v-if="parseInt(item.layout) === 1" />
        <News v-if="parseInt(item.layout) === 2" />
        <Partners v-if="parseInt(item.layout) === 3" />
        <SponsorProgram v-if="parseInt(item.layout) === 4" />
        <Network v-if="parseInt(item.layout) === 5" />
        <Location v-if="parseInt(item.layout) === 6" />
        <Contact v-if="parseInt(item.layout) === 7" />-->
      </v-expansion-panel-content>
      <Divider />
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import Divider from "../../components/dividers/Divider";
// import Service from "../../components/about_layout/Service";
// import News from "../../components/about_layout/News";
// import Partners from "../../components/about_layout/Partners";
// import SponsorProgram from "../../components/about_layout/SponsorProgram";
// import Network from "../../components/about_layout/Network";
// import Location from "../../components/about_layout/Location";
// import Contact from "../../components/about_layout/Contact";

export default {
  props: {
    items: {
      default: []
    },
    state: {
      default: null
    }
  },
  data: () => ({
    expanded: []
  }),
  created() {
    if (this.state) {
      this.expanded.push(this.state);
    }
  },
  components: {
    Divider
    // Service,
    // News,
    // Partners,
    // SponsorProgram,
    // Network,
    // Location,
    // Contact
  },
  methods: {
    expandHandler(index) {

    }
  }
};
</script>

<style></style>
